<template>
    <v-container fill-height fluid grid-list-xl>
        <v-layout wrap>
          <v-flex md12 sm12 lg12>
            <material-card
                icon="mdi-electricity-bill"
                color="indigo"
                :title="$t('Pages.ElectricityStats.title')">
              <v-card-text>
                <v-container>
                  <v-layout wrap>
                    <v-flex lg3>
                      <v-dialog
                          ref="dialog"
                          v-model="modal"
                          :return-value.sync="search.start"
                          persistent
                          lazy
                          full-width
                          width="290px"
                      >
                        <v-text-field
                            clearable
                            slot="activator"
                            v-model="computedStart"
                            :label="$t('Pages.Vacations.model.start')"
                            prepend-icon="event"
                            readonly
                            color="indigo"
                            :error-messages="errors.first('start')"
                            name="start"
                        ></v-text-field>
                        <v-date-picker locale="sr-Latn-RS" type="month" color="indigo" v-model="search.start" scrollable>
                          <v-spacer></v-spacer>
                          <v-btn flat @click="modal = false">{{$t('Core.Fields.cancel')}}</v-btn>
                          <v-btn flat color="indigo" @click="$refs.dialog.save(search.start)">{{$t('Core.Fields.ok')}}</v-btn>
                        </v-date-picker>
                      </v-dialog>
                    </v-flex>
                    <v-flex lg3>
                      <v-dialog
                          ref="dialogEnd"
                          v-model="modalEnd"
                          :return-value.sync="search.end"
                          persistent
                          lazy
                          full-width
                          width="290px"
                      >
                        <v-text-field
                            clearable
                            slot="activator"
                            v-model="computedEnd"
                            :label="$t('Pages.Vacations.model.end')"
                            prepend-icon="event"
                            readonly
                            color="indigo"
                            :error-messages="errors.first('end')"
                            name="end"
                        ></v-text-field>
                        <v-date-picker locale="sr-Latn-RS" :min="search.start" type="month" color="indigo" v-model="search.end" scrollable>
                          <v-spacer></v-spacer>
                          <v-btn flat @click="modal = false">{{$t('Core.Fields.cancel')}}</v-btn>
                          <v-btn flat color="indigo" @click="$refs.dialogEnd.save(search.end)">{{$t('Core.Fields.ok')}}</v-btn>
                        </v-date-picker>
                      </v-dialog>
                    </v-flex>
                    <v-flex lg3>
                      <v-autocomplete
                          :items="metrics"
                          v-model="search.metrics"
                          :error-messages="errors.first('metrics')"
                          :label="$t('Pages.ElectricityBills.model.metrics')"
                          name="sector"
                          color="indigo"
                          clearable
                          multiple
                          autocomplete
                          item-text="label"
                          return-object
                      ></v-autocomplete>
                    </v-flex>
                    <v-flex lg3>
                      <v-switch
                          v-model="showValues"
                          :label="$t('Pages.ElectricityStats.show_values')"
                          color="indigo"
                          name="broken"
                      ></v-switch>
                    </v-flex>
                    <v-flex md12 sm12 lg12 ref="chartdiv" class="chart">
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>
            </material-card>
          </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
    import * as am4core from "@amcharts/amcharts4/core";
    import * as am4charts from "@amcharts/amcharts4/charts";
    import am4themes_animated from "@amcharts/amcharts4/themes/animated";

    am4core.useTheme(am4themes_animated);

    export default {
        name: "ElectricityStats",
        components: {},
        data: () => ({
          modal: false,
          modalEnd: false,
          showValues: false,
          search: {start: null, end: null, metrics: null},
          metrics: [],
          bills: []
        }),
        computed:{
          computedStart: {
            get: function () {
              return this.getLocaleDateFormat(this.search.start).substr(1, 7);
            },
            set: function(val){
              this.search.start = val;
            }
          },
          computedEnd: {
            get: function () {
              return this.getLocaleDateFormat(this.search.end).substr(1, 7);
            },
            set: function(val){
              this.search.end = val;
            }
          }
        },
        mounted() {
          this.metrics = [
            {
              "label": this.$t('Pages.ElectricityBills.model.aevt'),
              "value": "aevt"
            },
            {
              "label": this.$t('Pages.ElectricityBills.model.aent'),
              "value": "aent"
            },
            {
              "label": this.$t('Pages.ElectricityBills.model.revt'),
              "value": "revt"
            },
            {
              "label": this.$t('Pages.ElectricityBills.model.rent'),
              "value": "rent"
            },
            {
              "label": this.$t('Pages.ElectricityBills.model.max_graph1'),
              "value": "max_graph1"
            },
            {
              "label": this.$t('Pages.ElectricityBills.model.max_graph2'),
              "value": "max_graph2"
            },
            {
              "label": this.$t('Pages.ElectricityBills.model.re_095'),
              "value": "re_095"
            },
            {
              "label": this.$t('Pages.ElectricityBills.model.exceeded_re_095'),
              "value": "exceeded_re_095"
            },
          ];
        },
        beforeDestroy() {
          this.destroyChart();
        },
        methods: {
          destroyChart() {
            if (this.chart) {
              this.chart.dispose();
            }
          },
          getBills() {
            this.loading = true;
            this.repositories.electricityBill.search(this.search).then(response => {
              this.bills = response.data.data;
              this.generateChart()
            }).finally(() => {
              this.loading = false;
            });
          },
          generateChart(data) {
            if (!this.search.metrics || !this.search.metrics || !this.bills || !this.bills.length) {
              return;
            }
            this.destroyChart();

            let chart = am4core.create(this.$refs.chartdiv, am4charts.XYChart);

            chart.paddingRight = 20;
            chart.minHeight = 500;
            chart.data = this.bills;

            let dateAxis = chart.xAxes.push(new am4charts.DateAxis());
            dateAxis.renderer.grid.template.location = 0;

            let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
            valueAxis.tooltip.disabled = true;
            valueAxis.renderer.minWidth = 35;

            for (let i = 0; i < this.search.metrics.length; i++) {
              var series = chart.series.push(new am4charts.LineSeries());
              series.dataFields.valueY = this.search.metrics[i].value;
              series.dataFields.dateX = "date";
              series.name = this.search.metrics[i].label;
              series.strokeWidth = 3;

              var bullet = series.bullets.push(new am4charts.CircleBullet());
              bullet.circle.strokeWidth = 2;
              if (!this.showValues) {
                bullet.tooltipText = this.search.metrics[i].label + ": [bold]{valueY}[/]";
                let hoverState = bullet.states.create("hover");
                hoverState.properties.scale = 1.7;
              } else {
                let labelBullet = series.bullets.push(new am4charts.LabelBullet());
                labelBullet.label.text = "[bold]{valueY}[/]";
                labelBullet.label.dy = -20;
              }
            }

            chart.cursor = new am4charts.XYCursor();
            chart.cursor.behavior = "zoomY";
            chart.legend = new am4charts.Legend();
            chart.exporting.menu = new am4core.ExportMenu();
            this.chart = chart;
          }
        },
        watch: {
          'search.start': function () {
            this.getBills();
          },
          'search.end': function () {
            this.getBills();
          },
          'search.metrics': function () {
            this.generateChart();
          },
          'showValues': function () {
            this.generateChart();
          }
        }
    }
</script>

<style scoped>
  .chart {
    height: 500px;
  }
</style>
